import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const commentsHistoryGet = async (referenceId, options) => {
  const resourcePath = `${Constants.PATH.COMMENTS.commentsHistory}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { referenceId },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export { commentsHistoryGet };
